export default "__VITE_ASSET__CgvrfsHO__"